/**
 * Closes the cart drawer when a Klaviyo popup/flyout opens.
 * The drawer is a modal dialog (showModal), which makes the Klaviyo popup inert and
 * closes on any click outside itself, so the popup could not be used while it was open.
 * Embedded forms fire "embedOpen" and are ignored.
 */
window.addEventListener('klaviyoForms', (event) => {
  if (!(event instanceof CustomEvent) || event.detail?.type !== 'open') return;

  /** @type {(HTMLElement & { close?: () => void }) | null} */
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer?.querySelector('dialog')?.open) cartDrawer.close?.();
});
